<template>
  <div
    v-if="user.data&&currentRoute"
    class="xpress-user-photo"
  >
    <span class="welcome-name mr-5">{{welcomeMessage}}&nbsp;</span>
    <n-dropdown
      class="text-info"
      trigger="hover"
      placement="bottom-end"
      :options="dashboardOptions"
      :show-arrow="false"
      @select="changeRoute"
    >
      <img :src="user.photo" alt="user photo">
    </n-dropdown>
  </div>
</template>

<script>
import { reactive, ref } from '@vue/reactivity'
import { computed, h, onBeforeMount, watch } from '@vue/runtime-core'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { NDropdown, NIcon } from 'naive-ui'

import {
  PersonCircleOutline as UserIcon,
  LogOutOutline as LogoutIcon
} from '@vicons/ionicons5'

import useConfig from '@/mixins/use-api-config'

export default {
  name: 'Current User Avatar',
  components: {
    NDropdown
  },
  setup () {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const { config } = useConfig()

    const user = reactive({
      data: computed(() => store.getters['users/_user']),
      photo: require('@/assets/img/icons/User.png')
    })

    const welcomeMessage = user.data?.firstName ? `Hi ${user.data.firstName}` : ''

    const currentRoute = ref(null)

    const renderIcon = (icon) => {
      return () => {
        return h(NIcon, null, {
          default: () => h(icon)
        })
      }
    }

    const dashboardOptions = ref([
      {
        label: 'Dashboard',
        key: 'dashboard',
        icon: renderIcon(UserIcon)
      },
      {
        label: 'Logout',
        key: 'logout',
        icon: renderIcon(LogoutIcon)
      }
    ])

    const changeRoute = route => {
      switch (route) {
        case 'dashboard':
          // route to current user's dashboard
          router.push('/dashboard')
          break

        case 'logout':
          store.dispatch('users/Logout', config)
            .then(() => {
              // route to home
              location.assign('/')
            })
          break
      }
    }

    const getCurrentRoute = path => {
      currentRoute.value = path.includes('/home') || path.includes('/api/')
    }

    // watch route changes
    watch(route, newRoute => getCurrentRoute(newRoute.path))

    onBeforeMount(() => getCurrentRoute(route.path))

    return {
      welcomeMessage,
      currentRoute,
      user,
      dashboardOptions,
      changeRoute
    }
  }
}
</script>

<style lang="scss" scoped>
  span.welcome-name {
    font-size: 13.5px;
  }
</style>
